module.exports = __webpack_public_path__ + "static/media/facebook-messenger.74740dc0.svg";